/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_EventInputs */

const en_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Event`)
};

const fr_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total d’événements`)
};

const de_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtereignis`)
};

const it_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento totale`)
};

const ru_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий`)
};

const es_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento total`)
};

const zh_cn2_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件`)
};

const ja_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント`)
};

const hi_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल घटना`)
};

const pt_pt2_total_event = /** @type {(inputs: Total_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento Total`)
};

/**
* | output |
* | --- |
* | "Total Event" |
*
* @param {Total_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const total_event = /** @type {((inputs?: Total_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_total_event(inputs)
	if (locale === "de") return de_total_event(inputs)
	if (locale === "it") return it_total_event(inputs)
	if (locale === "ru") return ru_total_event(inputs)
	if (locale === "es") return es_total_event(inputs)
	if (locale === "zh-CN") return zh_cn2_total_event(inputs)
	if (locale === "ja") return ja_total_event(inputs)
	if (locale === "hi") return hi_total_event(inputs)
	if (locale === "pt-PT") return pt_pt2_total_event(inputs)
	return en_total_event(inputs)
});